module.exports = __webpack_public_path__ + "img/payExamp.c5b124f7.png";